// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1ZbBv","productName":"Table_productName__2NvQ7"};